import * as _ from "lodash-es";
import React, { Component } from "react";
import { Dock } from "react-dock";
import Modal from "react-modal";
import QBDVendorsSyncStatus from "./QBDVendorsSyncStatus/QBDVendorsSyncStatus";
import QBDVendorSyncModal from "./QBDVendorSyncModal/QBDVendorSyncModal";
import SquareCustomerSync from "./SquareCustomerSync/SquareCustomerSync";
import SupplierVendorActionBtns from "./SupplierVendorActionBtns/SupplierVendorActionBtns";
import "./SupplierVendors.scss";
import VendorCsvModalUpload from "./VendorCsvModalUpload/VendorCsvModalUpload";
import VendorsFilter from "./VendorsFilter/VendorsFilter";
import VendorSidebar from "./VendorSidebar/VendorSidebar";
import { QuickBooksOnlineConnectCustomersModal } from "./QuickBooksOnlineConnectCustomersModal/QuickBooksOnlineConnectCustomersModal";
import { ZohoSyncAccountsModal } from "./ZohoSyncAccountsModal/ZohoSyncAccountsModal";
import { HubspotPullCompanies } from "./HubspotPullCompanies/HubspotPullCompanies";
import IQBOPullAndDownloadCustomersDTO from "../../../models/DTO/IQBOPullAndDownloadCustomersDTO";
import AttachmentListItem from "../../order_entry/OrderEntryFileManager/AttachmentListItem/AttachmentListItem";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import IDeleteFileUploadDTO from "../../../models/DTO/IDeleteFileUploadDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IQBOSyncCustomersDTO from "../../../models/DTO/IQBOSyncCustomersDTO";
import IQBDPushCustomersDTO from "../../../models/DTO/IQBDPushCustomersDTO";
import IOnGetVendorCsvDTO from "../../../models/DTO/IOnGetVendorCsvDTO";
import IQBOPullCustomersDTO from "../../../models/DTO/IQBOPullCustomersDTO";
import IQBOOnSyncCustomersDTO from "../../../models/DTO/IQBOOnSyncCustomersDTO";
import IOnGetAllSupplierTokensDTO from "../../../models/DTO/IOnGetAllSupplierTokensDTO";
import IQBOOnPullAndDownloadCustomersDTO from "../../../models/DTO/IQBOOnPullAndDownloadCustomersDTO";
import IQBDOnGetStoredDataDTO from "../../../models/DTO/IQBDOnGetStoredDataDTO";
import IOwTableCols from "../../../models/IOwTableCols";
import IHubspotOnPullCompaniesDTO from "../../../models/DTO/IHubspotOnPullCompaniesDTO";
import IOwTableConfig from "../../../models/IOwTableConfig";
import IQBDCreateVendorsDTO from "../../../models/DTO/IQBDCreateVendorsDTO";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import IntegrationsConnectedBar from "../../shared/IntegrationsConnectedBar/IntegrationsConnectedBar";
import OwBadge from "../../shared/OwBadge/OwBadge";
import FishbowlQueueTypeEnum from "../../../models/FishbowlQueueTypeEnum";
import IQBDMapperDTO from "../../../models/DTO/IQBDMapperDTO";
import IConnection_Token from "../../../models/IConnection_Token";
import IZohoGetAccountsDTO from "../../../models/DTO/IZohoGetAccountsDTO";
import SyncStatus from "../../shared/SyncStatus/SyncStatus";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IZohoGetAccountsProgressDTO from "../../../models/DTO/IZohoGetAccountsProgressDTO";
import SupplierGuidEnum from "../../../models/SupplierGuidEnum";
import IFishbowlCreateQueueItemDTO from "../../../models/DTO/IFishbowlCreateQueueItemDTO";
import IOnQBDPushCustomersDTO from "../../../models/DTO/IOnQBDPushCustomersDTO";
import OwActionBar from "../../shared/OwActionBar/OwActionBar";
import IQBOSetBulkVendorCustomerDetailsDTO from "../../../models/DTO/IQBOSetBulkVendorCustomerDetailsDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import OwLabel from "../../shared/OwLabel/OwLabel";
import IFishbowlPullCustomersDTO from "../../../models/DTO/IFishbowlPullCustomersDTO";
import IDeleteTokenDTO from "../../../models/DTO/IDeleteTokenDTO";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import IHubspotPullCompaniesDTO from "../../../models/DTO/IHubspotPullCompaniesDTO";
import IOnDeleteTokenDTO from "../../../models/DTO/IOnDeleteTokenDTO";
import IOnFishbowlPullCustomersDTO from "../../../models/DTO/IOnFishbowlPullCustomersDTO";
import IOnZohoGetAccountsDTO from "../../../models/DTO/IOnZohoGetAccountsDTO";
import IGetVendorCsvDTO from "../../../models/DTO/IGetVendorCsvDTO";
import IConnection_TokenUI from "../../../models/IConnection_TokenUI";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import UserTypesEnum from "../../../models/UserTypesEnum";
import IOnQBOGetAllCustomersDTO from "../../../models/DTO/IOnQBOGetAllCustomersDTO";
import IGetAllSupplierTokensDTO from "../../../models/DTO/IGetAllSupplierTokensDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IDataMapperSaveItem from "../../../models/IDataMapperSaveItem";
import IFishbowlPullCustomersProgressDTO from "../../../models/DTO/IFishbowlPullCustomersProgressDTO";
import OwTable from "../../shared/OwTable/OwTable";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import IGetFileUploadDTO from "../../../models/DTO/IGetFileUploadDTO";
import IQBOGetAllCustomersDTO from "../../../models/DTO/IQBOGetAllCustomersDTO";
import IHubspotPullCompaniesProgressDTO from "../../../models/DTO/IHubspotPullCompaniesProgressDTO";
import IOnQBDMapperDTO from "../../../models/DTO/IOnQBDMapperDTO";
import ISupplierModel from "../../../models/ISupplierModel";
import IFishbowlOnCreateQueueItemDTO from "../../../models/DTO/IFishbowlOnCreateQueueItemDTO";
import IColumns from "../../../models/IColumns";
import IOnUpdateUserSettingsDTO from "../../../models/DTO/IOnUpdateUserSettingsDTO";
import IQBDGetStoredDataDTO from "../../../models/DTO/IQBDGetStoredDataDTO";
import IAction from "../../../models/IAction";
import UserService from "../../../services/UserService";
import IOnQBOSetBulkVendorCustomerDetailsDTO from "../../../models/DTO/IOnQBOSetBulkVendorCustomerDetailsDTO";
import IOnGetFileUpload from "../../../models/DTO/IOnGetFileUpload";
import IOnGetVendorsDTO from "../../../models/DTO/IOnGetVendorsDTO";
import IPrice_Group from "../../../models/IPrice_Group";
import IQBOPushCustomersUpdateDTO from "../../../models/DTO/IQBOPushCustomersUpdateDTO";
import IOnSquareGetCustomersDTO from "../../../models/DTO/IOnSquareGetCustomersDTO";
import IAddress from "../../../models/IAddress";
import IGetVendorsDTO from "../../../models/DTO/IGetVendorsDTO";
import OwDoubleScrollbar from "../../shared/OwDoubleScrollbar/OwDoubleScrollbar";
import IXeroOnGetContactsDTO from "../../../models/DTO/IXeroOnGetContactsDTO";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import { OwDataMapper } from "../../shared/OwDataMapper/OwDataMapper";
import INotification from "../../../models/INotification";
import IFishbowlDownloadCustomersDTO from "../../../models/DTO/IFishbowlDownloadCustomersDTO";
import EditPriceGroupAccess from "../../users/Users/shared/EditPriceGroupAccess/EditPriceGroupAccess";
import IXeroGetContactsDTO from "../../../models/DTO/IXeroGetContactsDTO";
import ILoadUserDTO from "../../../models/DTO/ILoadUserDTO";
import IUserUI from "../../../models/IUserUI";
import IFishbowlOnDownloadCustomersDTO from "../../../models/DTO/IFishbowlOnDownloadCustomersDTO";
import SortOrderEnum from "../../../models/SortOrderEnum";
import ResourceTypesEnum from "../../../models/ResourceTypesEnum";
import { AccountsHeader } from "../AccountsHeader/AccountsHeader";
import { QboPushCustomersModal } from "./QboPushCustomersModal/QboPushCustomersModal";
import IQBOPushCustomersDTO from "../../../models/DTO/IQBOPushCustomersDTO";
import { QboPullCustomersModal } from "./QboPullCustomersModal/QboPullCustomersModal";
import { Socket } from "socket.io-client";
import { EditWarehouseAccess } from "./EditWarehouseAccess/EditWarehouseAccess";
import IWarehouse from "../../../models/IWarehouse";
import IGetWarehousesDTO from "../../../models/DTO/IGetWarehousesDTO";
import IOnGetWarehousesDTO from "../../../models/DTO/IOnGetWarehousesDTO";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import IQBDAccountAuditDTO from "../../../models/DTO/IQBDAccountAuditDTO";
import OwS3DownloadLink from "../../shared/OwS3DownloadLink/OwS3DownloadLink";
import { AccountDownloadCsvModal } from "../AccountDownloadCsvModal/AccountDownloadCsvModal";
import IQBOReconcileAccountsAndQBOCustomersDTO from "../../../models/DTO/IQBOReconcileAccountsAndQBOCustomersDTO";
import IQBOOnReconcileAccountsAndQBOCustomersDTO from "../../../models/DTO/IQBOOnReconcileAccountsAndQBOCustomersDTO";
import UIService from "../../../services/UIService";
import SupplierService from "../../../services/SupplierService";
import IQBDOnAccountAuditDTO from "../../../models/DTO/IQBDOnAccountAuditDTO";
import IShopifySyncCustomersDTO from "../../../models/DTO/IShopifySyncCustomersDTO";
import IShopifyOnSyncCustomersDTO from "../../../models/DTO/IShopifyOnSyncCustomersDTO";
import IGetVendorsPendingDTO from "../../../models/DTO/IGetVendorsPendingDTO";
import IOnGetVendorsPendingDTO from "../../../models/DTO/IOnGetVendorsPendingDTO";
import IVendorPending from "../../../models/IVendorPending";
import { VendorsPending } from "../VendorsPending/VendorsPending";
import IUpdateTokenSettingsDTO from "../../../models/DTO/IUpdateTokenSettingsDTO";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import CategorySidebar from "../../catalogs/CatalogOverview/CategorySidebar/CategorySidebar";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import AccessTypesEnum from "../../../models/AccessTypesEnum";
import IndustryNameEnum from "../../../models/IndustryNameEnum";
import { SearchSection } from "../../shared/SearchSection/SearchSection";
import { AccountActionsDropdown } from "./AccountActionsDropdown/AccountActionsDropdown";
import IGetCategoriesDTO from "@models/DTO/IGetCategoriesDTO";
import IOnGetCategoriesDTO from "@models/DTO/IOnGetCategoriesDTO";
import ICategory from "@models/ICategory";
import { ClickToCopy } from "@components/shared/ClickToCopy/ClickToCopy";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import { VendorSidebarFn } from "./VendorSidebar/VendorSidebarFn";
import { VENDORS_FILTER_ACTIONS_ID, VendorsFilterBar } from "./VendorsFilterBar/VendorsFilterBar";
import { FilterBarVersionToggle } from "@components/shared/FilterBarVersionToggle/FilterBarVersionToggle";
import { getFilterBarMode } from "@utils/filterBarVersion";

type Props = {
    socket: Socket;
    setActivityIndicator: (activityIndicator: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    history: any;
    location: any;
    showHiddenFeatures: boolean;
    isReadOnly: boolean;
};

type State = {
    supplierVendorTokens: IConnection_TokenUI[];
    priceGroups: IPrice_Group[];
    hasAvailableTokens: boolean;
    disableConnectToQBO: boolean;
    activeConnectToQBO: boolean;
    qbdAccountAuditActive: boolean;
    activeQboSyncCustomers: boolean;
    activeSyncWithSquare: boolean;
    disableSyncWithSquare: boolean;
    activeSyncWithZoho: boolean;
    disableSyncWithZoho: boolean;
    columns: IColumns;
    tableColumns: IOwTableCols[];
    limit: number;
    offset: number;
    totalSupplierVendors: number;
    userType?: any;
    queryString?: string;
    isReset?: boolean;
    searchResults?: boolean;
    squareIntegrationClass?: string;
    qboIntegrationClass?: string;
    zohoIntegrationClass?: string;
    qbdMapperVisible: boolean;
    qbdSelectableOptions: any[];
    actions: IAction[];
    catalogs: any[];
    salesPeopleAssigned?: any; // // email/name array
    dockComponent?: any;
    isDockVisible: boolean;
    sourceConfirmDeleteElem?: HTMLElement | null;
    navItems: IBreadcrumbs[];
    modalComponent: any;
    modalStyle: any;
    modalIsOpen: boolean;
    isDataFetching: boolean;
    isInitialData: boolean;
    tableConfig: IOwTableConfig;
    sortCol: string;
    sortDir: SortOrderEnum;
    qbdSyncVendorsActive: boolean;
    getVendorsActive: boolean;
    showSyncStatus: boolean;
    activeFishbowlSync: boolean;
    activeSyncXero: boolean;
    syncTotalProcessed: number;
    syncTotalItems: number;
    isSidebarOpen: boolean;
    rowToDelete?: IConnection_TokenUI | null;
    deleteIndex?: number | null;
    totalErrors?: number;
    errorDetails?: any[];
    zohoTotalProcessed: number;
    zohoTotalCreated: number;
    zohoTotalUpdated: number;
    hubspotTotalProcessed: number;
    activeHubspot: boolean;
    activeShopify: boolean;
    warehouses: IWarehouse[];
    vendorsPending: IVendorPending[];
    revokeRow: string | null;
    showMapsView: boolean;
    categories: ICategory[];
    useNewVendorSidebar: boolean;
};

class SupplierVendors extends Component<Props, State> {
    assignOverlayRef: any;
    sockets: IUiSocketSetup[] = [];

    static defaultProps = {
        totalSupplierVendors: 0,
        supplierVendorTokens: [],
        qboIntegrationClass: "",
        priceGroups: [],
        setSidebarComponent: () => {},
        toggleSidebar: () => {},
    };

    constructor(props: any) {
        super(props);

        const actions: IAction[] = [];

        const currentToken = UserService.getCurrentToken(this.props.userModel);

        const userCols = currentToken?.settings?.users_vendors_cols || {};

        const getColumnChecked = (objProp: string, defaultVal: boolean) => {
            let isChecked = defaultVal;

            if (!_.isNil(userCols) && !_.isNil(userCols[objProp])) {
                isChecked = userCols[objProp];
            }

            return isChecked;
        };

        const columns: IColumns = {
            name: { name: "name", label: "name", isChecked: getColumnChecked("name", true) },
            route: {
                name: "route",
                label: "sales_person_s",
                isChecked: getColumnChecked("route", true),
                notVisible: !this.props.supplierModel.has_routes,
            },
            sales_person_s: { name: "sales_person_s", label: "sales_person_s", isChecked: getColumnChecked("sales_person_s", true) },
            rep_group: {
                name: "rep_group",
                label: "rep_group",
                isChecked: getColumnChecked("rep_group", true),
                notVisible: !this.props.supplierModel.has_rep_groups,
            },
            email: { name: "email", label: "email", isChecked: getColumnChecked("email", true) },
            bill_to: { name: "bill_to", label: "bill_to", isChecked: getColumnChecked("bill_to", true) },
            ship_to: { name: "ship_to", label: "ship_to", isChecked: getColumnChecked("ship_to", true) },
            currency: { name: "currency", label: "currency", isChecked: getColumnChecked("currency", true) },
            category: {
                name: "category",
                label: "category",
                isChecked: getColumnChecked("category", true),
            },
            catalog_lock: {
                name: "catalog_lock",
                label: "catalog_lock",
                isChecked: getColumnChecked("catalog_lock", true),
            },
            price_group_lock: {
                name: "price_group_lock",
                label: "price_group_lock",
                isChecked: getColumnChecked("price_group_lock", true),
            },
            ffl_number: {
                name: "ffl_number",
                label: "ffl_number",
                isChecked: getColumnChecked("ffl_number", true),
                notVisible: !this.isFirearmsIndustry(),
            },
            fastbound_status: {
                name: "fastbound_status",
                label: "fastbound_account",
                isChecked: getColumnChecked("fastbound_status", true),
                notVisible: !this.hasFastBound(),
            },
            resale_tax_id: {
                name: "resale_tax_id",
                label: "resale_tax_id",
                isChecked: getColumnChecked("resale_tax_id", true),
            },
            payment_type: {
                name: "payment_type",
                label: "payment_type",
                isChecked: getColumnChecked("payment_type", true),
            },
            actions: {
                name: "actions",
                label: "",
                isChecked: getColumnChecked("actions", true),
                notVisible: true,
            },
        };

        this.state = {
            modalComponent: null,
            modalStyle: {},
            modalIsOpen: false,
            navItems: [],
            catalogs: [],
            supplierVendorTokens: [],
            priceGroups: [],
            hasAvailableTokens: false,
            disableConnectToQBO: false,
            activeConnectToQBO: false,
            activeQboSyncCustomers: false,
            activeSyncWithSquare: false,
            disableSyncWithSquare: false,
            activeSyncWithZoho: false,
            disableSyncWithZoho: false,
            qbdSyncVendorsActive: false,
            columns,
            tableColumns: [],
            limit: 5,
            offset: 0,
            totalSupplierVendors: 0,
            qbdAccountAuditActive: false,
            qbdMapperVisible: false,
            qbdSelectableOptions: [],
            actions,
            isDockVisible: false,
            isDataFetching: false,
            isInitialData: true,
            tableConfig: {
                tableHover: true,
                tableHasSort: true,
                alignHeadersMiddle: true,
            },
            sortCol: "name",
            sortDir: SortOrderEnum.ASC,
            getVendorsActive: false,
            showSyncStatus: false,
            activeFishbowlSync: false,
            syncTotalItems: 0,
            syncTotalProcessed: 0,
            isSidebarOpen: false,
            rowToDelete: null,
            deleteIndex: null,
            activeSyncXero: false,
            zohoTotalCreated: 0,
            zohoTotalProcessed: 0,
            zohoTotalUpdated: 0,
            activeHubspot: false,
            activeShopify: false,
            hubspotTotalProcessed: 0,
            warehouses: [],
            vendorsPending: [],
            revokeRow: null,
            showMapsView: true,
            categories: [],
            useNewVendorSidebar: false,
        };

        document.title = "Orderwerks >> Accounts";

        this.sockets = [
            { endpoint: EndpointsEnum.VendorsOnGetVendors, fn: this.onGetVendors },
            { endpoint: EndpointsEnum.SquareOnGetCustomers, fn: this.onSquareGetCustomers },
            { endpoint: EndpointsEnum.QBOOnGetAllCustomers, fn: this.onQboGetAllCustomers },
            { endpoint: EndpointsEnum.QBOOnSetBulkVendorCustomerDetails, fn: this.onQboSetBulkVendorCustomerDetails },
            { endpoint: EndpointsEnum.QBOOnPushCustomers, fn: this.onQboPushCustomers },
            { endpoint: EndpointsEnum.ZohoOnGetAccounts, fn: this.onZohoGetAccounts },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.QBDOnMapper, fn: this.onQbdMapper },
            { endpoint: EndpointsEnum.QBOOnSyncCustomers, fn: this.qboOnSyncCustomers },
            { endpoint: EndpointsEnum.TokenOnGetAllSupplierTokens, fn: this.onGetAllSupplierTokens },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: this.onGetCatalogs },
            { endpoint: EndpointsEnum.FileUploadOnGetFileUpload, fn: this.onGetFileUpload },
            { endpoint: EndpointsEnum.TokenOnDeleteToken, fn: this.onDeleteToken },
            { endpoint: EndpointsEnum.QBDOnCreateVendors, fn: this.onQbdSyncVendors },
            { endpoint: EndpointsEnum.QBOPullCustomersStart, fn: this.QBOPullCustomersStart },
            { endpoint: EndpointsEnum.QBOPullCustomersUpdate, fn: this.QBOPullCustomersUpdate },
            { endpoint: EndpointsEnum.QBOPushCustomersStart, fn: this.QBOPushCustomersStart },
            { endpoint: EndpointsEnum.QBOPushCustomersUpdate, fn: this.QBOPushCustomersUpdate },
            { endpoint: EndpointsEnum.QBDOnPushCustomers, fn: this.onQBDPushVendors },
            { endpoint: EndpointsEnum.VendorsOnGetVendorCsv, fn: this.onGetVendorCsv },
            { endpoint: EndpointsEnum.FishbowlOnPullCustomers, fn: this.onFishbowlPullCustomers },
            { endpoint: EndpointsEnum.QBDOnGetStoredData, fn: this.onQbdGetStoredData },
            { endpoint: EndpointsEnum.FishbowlPullCustomersProgress, fn: this.fishbowlPullCustomersProgress },
            { endpoint: EndpointsEnum.QBOOnPullAndDownloadCustomers, fn: this.onQboPullAndDownloadCustomerFn },
            { endpoint: EndpointsEnum.FishbowlOnCreateQueueItem, fn: this.onFishbowlCreateQueueItem },
            { endpoint: EndpointsEnum.TokenOnUpdateSettings, fn: this.onUpdateTokenSettings },
            { endpoint: EndpointsEnum.XeroOnGetContacts, fn: this.xeroOnGetContacts },
            { endpoint: EndpointsEnum.ZohoProcessingGetAccounts, fn: this.zohoGetAccountsProgress },
            { endpoint: EndpointsEnum.FishbowlOnDownloadCustomerCsv, fn: this.onFishbowlDownloadCustomerCsv },
            { endpoint: EndpointsEnum.HubspotOnPullCompanies, fn: this.onHubspotPullCompanies },
            { endpoint: EndpointsEnum.HubspotPullCompaniesProgress, fn: this.hubspotPullCompaniesProgress },
            { endpoint: EndpointsEnum.WarehouseOnGetWarehouses, fn: this.onGetWarehouses },
            { endpoint: EndpointsEnum.QBDOnAccountAudit, fn: this.onQbdAccountAudit },
            { endpoint: EndpointsEnum.QBOOnReconcileAccounts, fn: this.onQboDownloadReconcileAccountsFn },
            { endpoint: EndpointsEnum.ShopifyOnSyncCustomers, fn: this.onShopifySyncCustomers },
            { endpoint: EndpointsEnum.VendorOnGetVendorsPending, fn: this.onGetVendorsPending },
            { endpoint: EndpointsEnum.CategoriesOnGetCategories, fn: this.onGetCategories },
        ];
    }

    isFirearmsIndustry = (): boolean => {
        return this.props.supplierModel.Industries?.some((industry) => industry.name === IndustryNameEnum.Firearms) ?? false;
    };

    hasFastBound = (): boolean => {
        return !!this.props.supplierModel.Supplier_Integration?.has_fastbound;
    };

    renderFastBoundStatusFn = (data: IConnection_Token) => {
        const contactId = data.Vendor?.Vendor_Integration?.fastbound_contact_id;
        const accountId = data.Vendor?.Vendor_Integration?.fastbound_account_id;
        if (contactId) {
            return <i className="fas fa-check-circle text-success" title="FastBound Mapped" />;
        }
        if (accountId) {
            return <i className="fas fa-exclamation-triangle text-warning" title="FastBound Linked (contact mapping incomplete)" />;
        }
        return <i className="fas fa-minus-circle text-muted" title="Not linked to FastBound" />;
    };

    renderFflNumberFn = (data: IConnection_Token) => {
        return <div>{data.Vendor?.ffl_number || ""}</div>;
    };

    getTableColumns = (): IOwTableCols[] => {
        const tableColumns: IOwTableCols[] = [];

        tableColumns.push(
            {
                title: "",
                valueProp: "",
                isActionsCol: true,
                renderFn: this.renderEditActionColFn,
                renderFnEmitsRow: true,
            },
            {
                isSortable: true,
                sortFn: this.setSort,
                sortOrderFn: () => {
                    return this.state.sortDir;
                },
                renderFn: this.renderNameFn,
                renderFnEmitsRow: true,
                title: "name",
                valueProp: "Vendor",
                valueSubProp: "name",
                isChecked: () => {
                    return this.state.columns.name.isChecked;
                },
            }
        );

        if (this.props.supplierModel.has_routes) {
            tableColumns.splice(2, 0, {
                title: "route",
                valueProp: "",
                renderFn: this.renderRouteFn,
                renderFnEmitsRow: true,
            });
        }

        if (this.props.supplierModel.has_rep_groups) {
            tableColumns.push({
                title: "rep_group",
                valueProp: "",
                renderFn: this.renderRepGroupFn,
                renderFnEmitsRow: true,
            });
        } else {
            tableColumns.push({
                title: "sales_person_s",
                valueProp: "",
                renderFn: this.renderSalesPersonsFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.sales_person_s.isChecked;
                },
            });
        }

        tableColumns.push(
            {
                title: "email",
                valueProp: "Vendor",
                valueSubProp: "email",
                isChecked: () => {
                    return this.state.columns.email.isChecked;
                },
            },
            {
                title: "bill_to",
                valueProp: "Vendor",
                valueSubProp: "Bill_To",
                renderFn: this.renderAddressFn,
                isSortable: true,
                sortFn: this.setSort,
                sortOrderFn: () => {
                    return this.state.sortDir;
                },
                isChecked: () => {
                    return this.state.columns.bill_to.isChecked;
                },
            },
            {
                title: "ship_to",
                valueProp: "Vendor",
                valueSubProp: "Ship_To",
                renderFn: this.renderAddressFn,
                isSortable: true,
                sortFn: this.setSort,
                sortOrderFn: () => {
                    return this.state.sortDir;
                },
                isChecked: () => {
                    return this.state.columns.ship_to.isChecked;
                },
            },
            {
                title: "currency",
                valueProp: "Currency",
                valueSubProp: "id",
                renderFn: this.renderCurrencyFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.currency.isChecked;
                },
            },
            {
                title: "category",
                valueProp: "Category",
                valueSubProp: "name",
                renderFn: this.renderCategoryFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.category.isChecked;
                },
            },
            {
                title: "catalog_lock",
                valueProp: "Catalog",
                valueSubProp: "name",
                renderFn: this.renderCatalogLockFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.catalog_lock.isChecked;
                },
            },
            {
                title: "price_group_lock",
                valueProp: "Price_Group",
                valueSubProp: "value",
                renderFn: this.renderPriceGroupLockFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.price_group_lock.isChecked;
                },
            },
            {
                title: "payment_type",
                valueProp: "Payment",
                valueSubProp: "type",
                renderFn: this.renderPaymentTypeFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.payment_type.isChecked;
                },
            },
            {
                title: "resale_tax_id",
                valueProp: "",
                renderFn: this.renderResaleTaxFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.resale_tax_id.isChecked;
                },
            }
        );

        if (this.isFirearmsIndustry()) {
            tableColumns.push({
                title: "ffl_number",
                valueProp: "Vendor",
                valueSubProp: "ffl_number",
                renderFn: this.renderFflNumberFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.ffl_number.isChecked;
                },
            });
        }

        if (this.hasFastBound()) {
            tableColumns.push({
                title: "fastbound_account",
                valueProp: "Vendor",
                valueSubProp: "fastbound_account_id",
                renderFn: this.renderFastBoundStatusFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.fastbound_status.isChecked;
                },
            });
        }

        tableColumns.push({
            title: "connected",
            valueProp: "",
            renderFn: this.renderIntegrationsFn,
            renderFnEmitsRow: true,
        });

        return tableColumns;
    };

    async componentDidMount() {
        const userType = this.props.userModel.userType;

        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        const qbdSelectableOptions = this.getQbdSelectableOptions();

        const tableColumns: IOwTableCols[] = this.getTableColumns();

        const actions: IAction[] = [];

        if (this.props.userModel.userType?.id === UserTypesEnum.ADMIN) {
            actions.push({
                name: "categories",
                fn: this.showCategoriesSidebar,
            });

            if (this.props.supplierModel.Supplier_Integration.has_qbo) {
                actions.push({
                    name: "quickbooks_online",
                    isDropdownGroup: true,
                    groupActions: [
                        {
                            name: "connect_customers",
                            isActive: () => {
                                return this.state.activeConnectToQBO;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.qboGetAllCustomersFn,
                            leftIconClass: "fas fa-exchange",
                        },
                        {
                            name: "pull_customers",
                            isActive: () => {
                                return this.state.activeQboSyncCustomers;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.qboShowPullCustomersModal,
                            leftIconClass: "fas fa-exchange",
                        },
                        {
                            name: "push_customers",
                            isActive: () => {
                                return this.state.activeQboSyncCustomers;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.qboPushCustomersModalFn,
                            leftIconClass: "fas fa-exchange",
                        },
                        {
                            name: "download_data",
                            isActive: () => {
                                return this.state.activeQboSyncCustomers;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.qboPullAndDownloadCustomerFn,
                            leftIconClass: "fad fa-download",
                            btnClass: () => {
                                return this.props.showHiddenFeatures ? "" : "d-none";
                            },
                        },
                        {
                            name: "reconcile",
                            isActive: () => {
                                return this.state.activeQboSyncCustomers;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.qboDownloadReconcileAccountsFn,
                            leftIconClass: "fad fa-download",
                            btnClass: () => {
                                return this.props.showHiddenFeatures ? "" : "d-none";
                            },
                        },
                    ],
                });
            }

            if (this.props.supplierModel.Supplier_Integration.has_fishbowl) {
                actions.push({
                    name: "fishbowl",
                    isDropdownGroup: true,
                    groupActions: [
                        {
                            name: "queue_pull_customers",
                            isActive: () => {
                                return this.state.activeFishbowlSync;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.fishbowlQueuePullCustomers,
                            leftIconClass: "fas fa-exchange",
                        },
                        {
                            name: "download_csv",
                            isActive: () => {
                                return this.state.activeFishbowlSync;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.fishbowlDownloadCustomerCsv,
                            leftIconClass: "fas fa-download",
                            btnClass: () => {
                                return this.props.showHiddenFeatures ? "" : "d-none";
                            },
                        },
                    ],
                });
            }

            if (this.props.supplierModel.Supplier_Integration.has_qbd) {
                const qbdActions = {
                    name: "quickbooks_desktop",
                    isDropdownGroup: true,
                    groupActions: [
                        {
                            name: "vendor_mapper",
                            isSupplierVendorOverride: true,
                            isActive: () => {
                                return this.state.activeConnectToQBO;
                            },
                            fn: this.showVendorQBDDataMapper,
                            leftIconClass: "fad fa-exchange",
                        },
                        {
                            name: "vendor_sync",
                            isSupplierVendorOverride: true,
                            isActive: () => {
                                return this.state.qbdSyncVendorsActive;
                            },
                            fn: this.showVendorQBDSync,
                            leftIconClass: "fad fa-link",
                        },
                        {
                            name: "account_audit",
                            isActive: () => {
                                return this.state.qbdAccountAuditActive;
                            },
                            fn: this.qbdAccountAudit,
                            leftIconClass: "fad fa-check",
                            btnClass: () => {
                                return this.props.showHiddenFeatures ? "" : "d-none";
                            },
                        },
                    ],
                };

                const POPMOUNT_GUID = `ff93c919-a13c-48b6-bd97-e7423efd8250`;

                if (this.props.supplierModel.guid !== POPMOUNT_GUID) {
                    qbdActions.groupActions.push({
                        name: "push_vendors",
                        isSupplierVendorOverride: true,
                        isActive: () => {
                            return this.state.qbdSyncVendorsActive;
                        },
                        fn: this.qbdPushVendors,
                        leftIconClass: "fad fa-cloud-upload-alt",
                    });
                }

                actions.push(qbdActions);
            }

            if (this.props.supplierModel.Supplier_Integration.has_hubspot) {
                actions.push({
                    name: "hubspot",
                    isDropdownGroup: true,
                    groupActions: [
                        {
                            name: "pull_customers",
                            isActive: () => {
                                return this.state.activeHubspot;
                            },
                            fn: this.hubspotPullCompaniesModal,
                            leftIconClass: "fad fa-cloud-arrow-down",
                        },
                    ],
                });
            }

            if (this.props.supplierModel.Supplier_Integration.has_shopify) {
                actions.push({
                    name: "shopify",
                    isDropdownGroup: true,
                    groupActions: [
                        {
                            name: "pull_customers",
                            isActive: () => {
                                return this.state.activeShopify;
                            },
                            fn: this.shopifyPullCustomersModal,
                            leftIconClass: "fad fa-cloud-arrow-down",
                        },
                    ],
                });
            }

            if (this.props.supplierModel.Supplier_Integration.has_square) {
                actions.push({
                    name: "square",
                    isDropdownGroup: true,
                    groupActions: [
                        {
                            name: "sync_customers",
                            isActive: () => {
                                return this.state.activeSyncWithSquare;
                            },
                            fn: this.squareSyncCustomers,
                            leftIconClass: "fad fa-exchange",
                        },
                    ],
                });
            }

            if (this.props.supplierModel.Supplier_Integration.has_zoho) {
                actions.push({
                    name: "zoho",
                    isDropdownGroup: true,
                    groupActions: [
                        {
                            name: "sync_accounts",
                            isActive: () => {
                                return this.state.activeSyncWithZoho;
                            },
                            fn: this.zohoShowSyncModal,
                            leftIconClass: "fad fa-exchange",
                        },
                    ],
                });
            }

            if (this.props.supplierModel.Supplier_Integration.has_xero) {
                actions.push({
                    name: "xero",
                    isDropdownGroup: true,
                    groupActions: [
                        {
                            name: "pull_contacts",
                            isActive: () => {
                                return this.state.activeSyncXero;
                            },
                            fn: this.xeroGetContacts,
                            leftIconClass: "fad fa-exchange",
                        },
                    ],
                });
            }

            if (this.props.supplierModel.Supplier_Integration.has_unanet) {
                actions.push({
                    name: "unanet",
                    isDropdownGroup: true,
                    groupActions: [
                        {
                            name: "unanet_project_mapping",
                            fn: () => {
                                const basePath = SupplierService.updateStringWithVendorOverride("/vendors", this.props.supplierModel);
                                this.props.history(`${basePath}/unanet/project-mapping`);
                            },
                            leftIconClass: "fas fa-project-diagram",
                        },
                    ],
                });
            }
        }

        this.setState(
            {
                tableColumns,
                userType,
                actions,
            },
            () => {
                // this.getVendors();
                // this.getAllSupplierTokens();
                this.getCatalogs();
                this.getCategories();

                if (this.props.supplierModel.has_warehouses) {
                    this.getWarehouses();
                }

                if (this.props.supplierModel.has_customer_module) {
                    this.getVendorsPending();
                }
            }
        );
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    showCategoriesSidebar = () => {
        const component = (
            <CategorySidebar
                notifyFn={this.props.notifyFn}
                cancel={() => {
                    this.props.toggleSidebar(false);
                }}
                saveFn={() => {}}
                socket={this.props.socket}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                isSimpleCategories={true}
            />
        );

        this.props.setSidebarComponent(component);

        this.props.toggleSidebar(true);
    };

    xeroGetContacts = () => {
        const payload: IXeroGetContactsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.XeroGetContacts, payload);

        this.setState({
            activeSyncXero: true,
        });
    };

    xeroOnGetContacts = (data: IXeroOnGetContactsDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_customers",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            activeSyncXero: false,
        });
    };

    getCategories = () => {
        const payload: IGetCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            onlyRootCategories: true,
            isVendorCategory: true,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
    };

    onGetCategories = (data: IOnGetCategoriesDTO) => {
        this.setState({
            categories: data.categories,
        });
    };

    setSort = (sortCol: string, sortOrder: SortOrderEnum) => {
        this.setState(
            {
                sortCol,
                sortDir: sortOrder,
            },
            () => {}
        );
    };

    renderSalesPersonsFn = (data: IConnection_Token) => {
        const salesPeopleAssigned = this.getSupplierVendorTokenSalesPerson(data);

        const salesPeople = _.map(salesPeopleAssigned, (user: IUserUI, index: number) => {
            return <div key={index}>{user.name}</div>;
        });

        return <div>{salesPeople}</div>;
    };

    renderRepGroupFn = (data: IConnection_Token) => {
        if (this.props.supplierModel.has_rep_groups) {
            const repGroups = data.Vendor?.Rep_Groups?.map((repGroup) => {
                return <div key={repGroup.guid}>{repGroup.name}</div>;
            });

            return <div>{repGroups}</div>;
        } else {
            return null;
        }
    };

    renderRouteFn = (data: IConnection_Token) => {
        if (this.props.supplierModel.has_routes) {
            const routeName = data.Vendor?.Route?.name;

            return <div>{routeName}</div>;
        } else {
            return null;
        }
    };

    renderIntegrationsFn = (data: IConnection_Token) => {
        const qboCustomerId = _.get(data, "Vendor.Vendor_Integration.qbo_CustomerId", "");
        const square_customer_id = _.get(data, "Vendor.Vendor_Integration.square_customer_id", "");
        const zoho_account_id = _.get(data, "Vendor.Vendor_Integration.zoho_account_id", "");
        const qbdListId = _.get(data, "Vendor.Vendor_Integration.qbd_ListID", "");
        const fishbowlId = _.get(data, "Vendor.Vendor_Integration.fishbowl_id", "");
        const xeroContactId = _.get(data, "Vendor.Vendor_Integration.xero_contact_id", "");
        const hubspotId = _.get(data, "Vendor.Vendor_Integration.hubspot_company_id", "");
        const fastboundAccountId = (_.get(data, "Vendor.Vendor_Integration.fastbound_account_id", "") || "").toString();

        return (
            <IntegrationsConnectedBar
                shipstationConnected={false}
                supplierModel={this.props.supplierModel}
                qboConnected={!_.isNil(qboCustomerId) && qboCustomerId.length}
                qbdConnected={!_.isNil(qbdListId) && qbdListId.length}
                squareConnected={!_.isNil(square_customer_id) && square_customer_id}
                zohoConnected={!_.isNil(zoho_account_id) && zoho_account_id.length}
                fishbowlConnected={!_.isNil(fishbowlId) && fishbowlId.length}
                xeroConnected={!_.isNil(xeroContactId) && xeroContactId.length}
                hubspotConnected={!_.isNil(hubspotId) && hubspotId.length}
                fastboundConnected={!_.isNil(fastboundAccountId) && fastboundAccountId.length}
                wooCommerceConnected={false}
                shopifyConnected={false}
                showIntegrations={{
                    quickbooksOnline: true,
                    quickbooksDesktop: true,
                    square: true,
                    shipstation: false,
                    zoho: true,
                    wooCommerce: false,
                    shopify: false,
                    fishbowl: true,
                    xero: true,
                    hubspot: true,
                    fastbound: this.hasFastBound(),
                }}
            />
        );
    };

    viewContacts = (token: IConnection_TokenUI, index: number) => {
        this.props.history(`/account/${token.Vendor!.guid}/contacts`);
    };

    onGetFileUpload = (data: IOnGetFileUpload) => {
        let supplierVendorToken: IConnection_Token;
        let attachment: any;

        for (const token of this.state.supplierVendorTokens) {
            if (token.Vendor) {
                if (token.Vendor.Resale_Tax_Attachment?.etag === data.ETag) {
                    supplierVendorToken = token;
                    attachment = token.Vendor.Resale_Tax_Attachment;
                }

                if (token.Vendor.Credit_Card_Auth_Attachment?.etag === data.ETag) {
                    supplierVendorToken = token;
                    attachment = token.Vendor.Credit_Card_Auth_Attachment;
                }

                // if (token.Vendor.State_License_Attachment?.etag === data.ETag) {
                //     supplierVendorToken = token;
                //     attachment = token.Vendor.State_License_Attachment;
                // }
            }
        }

        if (attachment) {
            // console.log("onGetFileUpload", data);
            const blob = new Blob([data.Body], { type: data.ContentType });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);

            const fileName = attachment!.name;

            link.download = fileName;
            link.click();
        }
    };

    renderCategoryFn = (data: IConnection_Token) => {
        if (data.Vendor?.Category) {
            return data.Vendor.Category?.name;
        }
    };

    renderCatalogLockFn = (data: IConnection_Token) => {
        let catalogLock: any = null;
        let catalogLockMap: any = null;

        if (data.Vendor?.lock_catalog_id) {
            catalogLock = <div>{data.Vendor.Catalog?.name}</div>;
        }

        if (data.Vendor?.has_price_group_restrictions) {
            if (data.Vendor?.Price_Groups_Map) {
                catalogLockMap = data.Vendor.Price_Groups_Map.map((mapItem) => {
                    return <div key={mapItem.guid}>{mapItem.Price_Group?.Catalog?.name}</div>;
                });
            }
        }

        return (
            <div>
                {catalogLock}
                {catalogLockMap}
            </div>
        );
    };

    renderPriceGroupLockFn = (data: IConnection_Token) => {
        let priceGroupLock: any = null;
        let priceGroupLockMap: any = null;

        if (data.Vendor?.price_group_id) {
            priceGroupLock = <div>{data.Vendor.Price_Group?.value}</div>;
        }

        if (data.Vendor?.has_price_group_restrictions) {
            if (data.Vendor?.Price_Groups_Map) {
                priceGroupLockMap = data.Vendor.Price_Groups_Map.map((mapItem) => {
                    return <div key={mapItem.guid}>{mapItem.Price_Group?.value}</div>;
                });
            }
        }

        return (
            <div>
                {priceGroupLock}
                {priceGroupLockMap}
            </div>
        );
    };

    renderPaymentTypeFn = (data: IConnection_Token) => {
        if (data.Vendor?.Payment_Type) {
            return data.Vendor.Payment_Type?.name;
        }
    };

    renderEditActionColFn = (data: IConnection_Token, index: number) => {
        if (this.props.userModel?.supplierUserToken?.access_type_id === AccessTypesEnum.READ_ONLY || this.props.isReadOnly) {
            return null;
        }

        if (data) {
            return (
                <div className="d-flex">
                    <OwDeleteEditActions
                        isEditMode={false}
                        onTrashClickFn={() => {
                            this.toggleConfirmDelete(data, index, null);
                        }}
                        onEditClickFn={() => {
                            this.showSupplierVendorSidebar(data);
                        }}
                        hideTrash={(this.props.userModel.isSupplierUser && this.props.userModel.userType?.id !== UserTypesEnum.ADMIN) || data.is_master}
                    />
                    <AccountActionsDropdown
                        supplierVendorToken={data}
                        toggleDockFn={this.toggleDock}
                        editWarehouseAccessFn={this.editWarehouseAccess}
                        rowIndex={index}
                        toggleConfirmDeleteFn={this.toggleConfirmDelete}
                        viewContacts={this.viewContacts}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    viewAccountDetailView = (row: IConnection_Token) => {
        if (row.Vendor) {
            this.props.history(`/account/${row.Vendor.guid}/detail`);
        }
    };

    renderNameFn = (data: IConnection_Token) => {
        if (data) {
            return (
                <div>
                    <div>{data.Vendor?.name || ""}</div>
                    {data.Vendor?.customer_internal_id ? <div className={"text-muted"}>{data.Vendor.customer_internal_id}</div> : null}
                    {data.Vendor?.Parent_Vendor ? (
                        <div className={"text-muted"}>
                            <OwLabel title={"parent"} noBottomMargin={true} postText={":"} className={"me-2"} />
                            {data.Vendor.Parent_Vendor.name}
                        </div>
                    ) : null}
                    {data.Vendor?.active ? null : (
                        <OwLabel leftIconClass={"fad fa-times-circle"} title={"inactive"} className={"text-danger"} />
                    )}
                    {data.Vendor?.is_ecomm_user ? (
                        <div>
                            <OwBadge title={"ecomm_user"} bgColor={"bg-warning"} />
                            {data.Vendor?.net_term_ecomm_user ? (
                                <span className={"ms-2"}>
                                    <OwBadge title={"net_terms"} bgColor={"bg-primary"} textColor={"white"} />
                                </span>
                            ) : null}
                        </div>
                    ) : null}
                    <div>
                        <OwLabel
                            title={"detail_view"}
                            fn={() => {
                                this.viewAccountDetailView(data);
                            }}
                        />
                    </div>
                    {data.Vendor?.Order_Assigned_User ? (
                        <div className={"mt-3"}>
                            <OwLabel title={"default_order_assigned_user"} noBottomMargin={true} isBold={true} className={"me-2"} />
                            <div>
                                <div className={""}>{data.Vendor?.Order_Assigned_User?.name}</div>
                                <div className={"text-small text-muted"}>{data.Vendor?.Order_Assigned_User?.email}</div>
                            </div>
                        </div>
                    ) : null}
                    {data.Vendor?.State_License_Attachment ? (
                        <div className={"mt-3"}>
                            <OwS3DownloadLink
                                attachment={data.Vendor?.State_License_Attachment}
                                title={"state_license"}
                                noFilename={true}
                                leftIconName={"fa-solid fa-download"}
                                isReadOnly={true}
                            />
                        </div>
                    ) : null}
                    {this.props.showHiddenFeatures && data.Vendor ? (
                        <div className="d-flex flex-column">
                            {this.props.supplierModel.Supplier_Integration.has_qbd ? (
                                <div className="d-flex align-items-center">
                                    <b className="me-2">QBD ListID:</b>
                                    <ClickToCopy
                                        label={data.Vendor.Vendor_Integration?.qbd_ListID || ""}
                                        text={data.Vendor.Vendor_Integration?.qbd_ListID || ""}
                                    />
                                </div>
                            ) : null}
                            <div className="d-flex align-items-center">
                                <b className="me-2">GUID:</b>
                                <ClickToCopy text={data.Vendor.guid.toString()} />
                            </div>
                            <div className="d-flex align-items-center">
                                <b className="me-2">ID:</b>
                                <ClickToCopy text={data.Vendor.id.toString()} />
                            </div>
                        </div>
                    ) : null}
                </div>
            );
        } else {
            return null;
        }
    };

    QBOPullCustomersStart = (data: IQBOPullCustomersDTO) => {
        this.setState({
            showSyncStatus: true,
            syncTotalItems: data.totalItems,
            syncTotalProcessed: data.totalProcessed,
        });
    };

    QBOPushCustomersStart = (data: IQBOPushCustomersUpdateDTO) => {
        this.setState({
            showSyncStatus: true,
            syncTotalItems: data.totalItems,
            syncTotalProcessed: data.totalProcessed,
        });
    };

    QBOPushCustomersUpdate = (data: IQBOPushCustomersUpdateDTO) => {
        this.setState({
            syncTotalItems: data.totalItems,
            syncTotalProcessed: data.totalProcessed,
        });
    };

    QBOPullCustomersUpdate = (data: IQBOPullCustomersDTO) => {
        this.setState({
            syncTotalItems: data.totalItems,
            syncTotalProcessed: data.totalProcessed,
        });
    };

    downloadAttachment = (supplierVendorToken: IConnection_Token, attachmentGuid: string) => {
        if (!this.props.userModel) {
            return null;
        }

        const vendorModel = supplierVendorToken.Vendor;

        const payload: IGetFileUploadDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            attachmentGuid,
            vendorGuid: vendorModel ? vendorModel.guid : undefined,
        };

        this.props.socket.emit(EndpointsEnum.FileUploadGetFileUpload, payload);
    };

    deleteAttachment = (supplierVendorToken: IConnection_Token, attachmentGuid: string) => {
        if (!this.props.userModel) {
            return null;
        }

        const vendorModel = supplierVendorToken.Vendor;

        const payload: IDeleteFileUploadDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            attachmentGuid,
            vendorGuid: vendorModel ? vendorModel.guid : undefined,
        };

        this.props.socket.emit(EndpointsEnum.FileUploadDeleteFileUpload, payload);
    };

    getResaleAttachmentLink = (supplierVendorToken: IConnection_Token, resaleTaxAttachmentId: number) => {
        let resaleTaxAttachmentLink: any = null;

        if (resaleTaxAttachmentId && supplierVendorToken.Vendor && supplierVendorToken.Vendor.Resale_Tax_Attachment) {
            resaleTaxAttachmentLink = (
                <AttachmentListItem
                    attachment={supplierVendorToken.Vendor.Resale_Tax_Attachment}
                    downloadAttachment={(attachmentGuid) => {
                        this.downloadAttachment(supplierVendorToken, attachmentGuid);
                    }}
                    deleteAttachment={(attachmentGuid) => {
                        this.deleteAttachment(supplierVendorToken, attachmentGuid);
                    }}
                    isReadOnly={true}
                    nameOverride={<OwTranslate defaultMessage={"resale tax doc"} id={"resale_tax_doc"} />}
                />
            );
        }

        return resaleTaxAttachmentLink;
    };

    downloadCSVData = (csvData: any, filename: string) => {
        const blob = new Blob([csvData], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = filename;
        link.click();
    };

    renderResaleTaxFn = (data: IConnection_Token) => {
        let dom: any = "";

        if (data.Vendor?.resale_tax_id) {
            dom = <div>{data.Vendor?.resale_tax_id}</div>;
        }

        if (data.Vendor?.resale_tax_attachment_id) {
            const attachmentListItem = this.getResaleAttachmentLink(data, data.Vendor.resale_tax_attachment_id);

            dom = (
                <div>
                    {dom}
                    {attachmentListItem}
                </div>
            );
        }

        return dom;
    };

    renderCurrencyFn = (data: IConnection_Token) => {
        if (data.Vendor?.Currency) {
            return data.Vendor.Currency.name;
        } else {
            return null;
        }
    };

    renderAddressFn = (data: IAddress) => {
        return (
            <div className={"d-flex"}>
                {this.props.supplierModel.has_google_maps && this.state.showMapsView ? (
                    <OwGoogleStaticMap address={data} className={"me-2"} size={"120x120"} />
                ) : null}
                <AddressDisplay
                    address={data}
                    showPhone={true}
                    hideMobile={true}
                    showCompanyName={true}
                    showName={true}
                    hideEmail={true}
                    showInternalId={true}
                />
            </div>
        );
    };

    onDeleteToken = (data: IOnDeleteTokenDTO) => {
        this.getAllSupplierTokens();
    };

    getAllSupplierTokens = () => {
        const payload: IGetAllSupplierTokensDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            usersLimit: 0,
            usersOffset: 0,
            vendorsLimit: this.state.limit,
            vendorsOffset: this.state.offset,
            vendorUsersLimit: 0,
            vendorUsersOffset: 0,
        };

        this.props.socket.emit("getAllSupplierTokens", payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetAllSupplierTokens = (data: IOnGetAllSupplierTokensDTO) => {
        this.setState({
            supplierVendorTokens: data.tokens.supplierVendorTokens,
            totalSupplierVendors: data.tokens.totalSupplierVendors,
            salesPeopleAssigned: data.tokens.salesPeopleAssigned,
            isDataFetching: false,
            isInitialData: false,
        });
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit("getCatalogs", payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        const state: any = {
            catalogs: data.catalogs,
        };

        this.setState(state);
    };

    fishbowlDownloadCustomerCsv = () => {
        const payload: IFishbowlDownloadCustomersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.FishbowlDownloadCustomerCsv, payload);

        this.setState({
            activeFishbowlSync: true,
        });
    };

    onFishbowlDownloadCustomerCsv = (data: IFishbowlOnDownloadCustomersDTO) => {
        const blob = new Blob([data.csvData], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const fileName = data.filename;

        link.download = fileName;
        link.click();

        this.setState({
            activeFishbowlSync: false,
        });
    };

    fishbowlQueuePullCustomers = () => {
        const payload: IFishbowlCreateQueueItemDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            type: FishbowlQueueTypeEnum.PULL_CUSTOMERS,
            details: null,
        };

        this.props.socket.emit(EndpointsEnum.FishbowlCreateQueueItem, payload);

        this.setState({
            activeFishbowlSync: true,
        });
    };

    onFishbowlCreateQueueItem = (data: IFishbowlOnCreateQueueItemDTO) => {
        const notification: INotification = {
            title: "created_queue_item",
            message: "check_email_once_completed",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            activeFishbowlSync: false,
        });
    };

    fishbowlPullCustomers = () => {
        const payload: IFishbowlPullCustomersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.FishbowlPullCustomers, payload);

        this.setState({
            activeFishbowlSync: true,
            showSyncStatus: true,
        });
    };

    fishbowlPullCustomersProgress = (data: IFishbowlPullCustomersProgressDTO) => {
        this.setState({
            syncTotalItems: data.totalItems,
            syncTotalProcessed: data.totalProcessed,
        });
    };

    onFishbowlPullCustomers = (data: IOnFishbowlPullCustomersDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_fishbowl_customers",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            activeFishbowlSync: false,
        });
    };

    qboPushCustomersModalFn = () => {
        const modalComponent = <QboPushCustomersModal startFn={this.qboPushCustomersFn} closeModalFn={this.closeModal} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    qboPushCustomersFn = (options: { onlyUnconnected: boolean }) => {
        const payload: IQBOPushCustomersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            onlyUnconnected: options.onlyUnconnected,
        };

        this.props.socket.emit(EndpointsEnum.QBOPushCustomers, payload);

        this.setState({
            activeQboSyncCustomers: true,
            modalIsOpen: false,
        });
    };

    qboShowPullCustomersModal = () => {
        const modalComponent = <QboPullCustomersModal closeModalFn={this.closeModal} startPullFn={this.qboPullCustomersFn} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    qboPullCustomersFn = (lastPullTime?: string) => {
        const payload: IQBOSyncCustomersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            lastPullTime,
        };

        this.props.socket.emit(EndpointsEnum.QBOSyncCustomers, payload);

        this.setState({
            activeQboSyncCustomers: true,
            modalComponent: null,
            modalIsOpen: false,
        });
    };

    qboDownloadReconcileAccountsFn = () => {
        const payload: IQBOReconcileAccountsAndQBOCustomersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOReconcileAccounts, payload);

        this.setState({
            activeQboSyncCustomers: true,
        });
    };

    onQboDownloadReconcileAccountsFn = (data: IQBOOnReconcileAccountsAndQBOCustomersDTO) => {
        if (data) {
            UIService.downloadDataFile(data.workbook, `${this.props.supplierModel.name}-qbo-accounts.xlsx`, "application/vnd.ms-excel");

            this.setState({
                activeQboSyncCustomers: false,
            });
        }
    };

    qboPullAndDownloadCustomerFn = () => {
        const payload: IQBOPullAndDownloadCustomersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOPullAndDownloadCustomers, payload);

        this.setState({
            activeQboSyncCustomers: true,
        });
    };

    onQboPullAndDownloadCustomerFn = (data: IQBOOnPullAndDownloadCustomersDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                activeQboSyncCustomers: false,
            });
        }
    };

    qboOnSyncCustomers = (data: IQBOOnSyncCustomersDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_customers",
            position: NotificationPositionEnum.br,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        const state: any = {
            activeQboSyncCustomers: false,
        };

        if (data.erroredCustomers) {
            state.totalErrors = data.erroredCustomers;
            state.errorDetails = data.errorDetails;
        }

        this.setState(state);
    };

    getQbdSelectableOptions = () => {
        if (
            this.props.supplierModel.Supplier_Integration.has_qbd &&
            this.props.userModel.isSupplierUser &&
            this.props.userModel.userType?.id === UserTypesEnum.ADMIN
        ) {
            const payload: IQBDGetStoredDataDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                type: "customer",
            };

            this.props.socket.emit(EndpointsEnum.QBDGetStoredData, payload);
        }
    };

    onQbdGetStoredData = (data: IQBDOnGetStoredDataDTO) => {
        let storedData: any = data.storedData;

        if (_.isString(data.storedData)) {
            storedData = JSON.parse(storedData);
        }

        this.setState({
            qbdSelectableOptions: storedData,
        });
    };

    notify = (data: IErrorDTO) => {
        this.setState({
            activeSyncWithSquare: false,
            disableSyncWithSquare: false,
            activeSyncWithZoho: false,
            disableSyncWithZoho: false,
            activeConnectToQBO: false,
            disableConnectToQBO: false,
            activeQboSyncCustomers: false,
        });
    };

    editWarehouseAccess = (supplierVendorToken?: IConnection_TokenUI) => {
        if (supplierVendorToken) {
            const dockComponent = (
                <EditWarehouseAccess
                    vendorModel={supplierVendorToken.Vendor!}
                    notifyFn={this.props.notifyFn}
                    socket={this.props.socket}
                    availableWarehouses={this.state.warehouses}
                    closeFn={this.toggleDock}
                />
            );

            this.toggleDockComponent(dockComponent, null);
        }
    };

    toggleDock = (supplierVendorToken?: IConnection_TokenUI) => {
        if (supplierVendorToken) {
            // load up the dock.
            const dockComponent = (
                <EditPriceGroupAccess
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    vendorModel={supplierVendorToken.Vendor!}
                    notifyFn={this.props.notifyFn}
                    socket={this.props.socket}
                />
            );

            this.toggleDockComponent(dockComponent, null);
        } else {
            // const dockComponent = this.getDockComponent();
            this.toggleDockComponent(null, null);
        }
    };

    toggleDockComponent = (component: any, callbackFn?: any) => {
        if (component) {
            this.setState(
                {
                    dockComponent: component,
                    isDockVisible: true,
                },
                callbackFn
            );
        } else {
            this.setState(
                {
                    dockComponent: null,
                    isDockVisible: false,
                },
                callbackFn
            );
        }
    };

    lockPriceGroup = (data: any, supplierVendorToken: any, index: number) => {
        const supplierVendorTokens = this.state.supplierVendorTokens;

        supplierVendorTokens[index].isDirty = true;

        this.setState({
            supplierVendorTokens,
        });
    };

    toggleSidebar = (refresh: boolean) => {
        this.props.toggleSidebar(false);

        this.props.socket.on(EndpointsEnum.FileUploadOnGetFileUpload, this.onGetFileUpload);

        this.setState(
            {
                isSidebarOpen: false,
            },
            () => {
                this.getVendors();
            }
        );
    };

    getSupplierVendorSidebarComponent = (supplierVendor?: IConnection_Token) => {
        if (this.state.useNewVendorSidebar) {
            return (
                <VendorSidebarFn
                    cancel={this.toggleSidebar}
                    supplierVendor={supplierVendor}
                    supplierModel={this.props.supplierModel}
                    userModel={this.props.userModel}
                    userType={this.state.userType}
                    socket={this.props.socket}
                    priceGroups={this.state.priceGroups}
                    notifyFn={this.props.notifyFn}
                />
            );
        } else {
            return (
                <VendorSidebar
                    cancel={this.toggleSidebar}
                    priceGroups={this.state.priceGroups}
                    catalogs={this.state.catalogs}
                    supplierVendor={supplierVendor}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    userType={this.state.userType}
                    // userModel={this.props.userModel} // there are both undefined in the component for some reason
                    // supplierModel={this.props.supplierModel}
                />
            );
        }
    };

    showSupplierVendorSidebar = (supplierVendor?: IConnection_Token) => {
        const sidebarComp = this.getSupplierVendorSidebarComponent(supplierVendor);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar();

        this.props.socket.removeListener(EndpointsEnum.FileUploadOnGetFileUpload, this.onGetFileUpload);

        this.setState({
            isSidebarOpen: true,
        });
    };

    getSupplierVendorTokenSalesPerson = (supplierVendorToken: IConnection_Token) => {
        const { salesPeopleAssigned } = this.state;

        const salesPeople: any[] = [];

        _.each(salesPeopleAssigned, (salesUserRow: any) => {
            if (salesUserRow.vendor_id === supplierVendorToken.vendor_id) {
                salesPeople.push(salesUserRow.User);
            }
        });

        return salesPeople;
    };

    toggleConfirmDelete = (data: IConnection_TokenUI, index: number, rowRef: HTMLElement | null) => {
        this.setState({
            revokeRow: `row-${index}`,
            sourceConfirmDeleteElem: rowRef,
            rowToDelete: data,
            deleteIndex: index,
        });
    };

    commitDelete = () => {
        if (this.state.rowToDelete) {
            const row = this.state.rowToDelete;

            const data: IDeleteTokenDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                tokenGuid: row.guid,
            };

            this.props.socket.emit(EndpointsEnum.TokenDeleteToken, data);

            this.setState({
                revokeRow: null,
                sourceConfirmDeleteElem: null,
                rowToDelete: undefined,
            });
        }
    };

    cancelDelete = () => {
        // @ts-expect-error

        this.deleteIndex = undefined;

        this.setState({
            revokeRow: null,
            sourceConfirmDeleteElem: null,
        });
    };

    saveToken = (e: any, token: any, tokenType: any) => {
        const data: any = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        let recipient = _.get(token, "User.email", "");

        if (!recipient.length) {
            recipient = _.get(token, "Vendor.email", "");
        }

        data.recipient = recipient;

        if (tokenType === "VendorUser") {
            // add the Vendor Guid to the data
            data.vendorGuid = token.vendorGuid;
        }

        this.props.socket.emit(`generate${tokenType}Token`, data);
    };

    getSuppliersVendorsBody = () => {
        let suppliersVendorsBody: any | null = null;

        if (!_.isNil(this.state.supplierVendorTokens) && !_.isNil(this.props.supplierModel)) {
            const processedSupplierVendorRows = this.state.supplierVendorTokens.map((supplierVendorToken, index: number) => {
                const salesPeople = this.getSupplierVendorTokenSalesPerson(supplierVendorToken);

                // return (
                //     <SupplierVendorsRow
                //         key={index}
                //         ref={`supplierVendor-${index}`}
                //         catalogs={this.state.catalogs}
                //         supplierModel={this.props.supplierModel}
                //         userType={this.state.userType}
                //         userModel={this.props.userModel}
                //         supplierVendorToken={supplierVendorToken}
                //         index={index}
                //         toggleConfirmDeleteFn={this.toggleConfirmDelete}
                //         lockPriceGroupFn={this.lockPriceGroup}
                //         saveTokenFn={this.saveToken}
                //         priceGroups={this.state.priceGroups}
                //         toggleSidebar={this.props.toggleSidebar}
                //         setSidebarComponent={this.props.setSidebarComponent}
                //         socket={this.props.socket}
                //         columns={this.state.columns}
                //         salesPeople={salesPeople}
                //         notifyFn={this.props.notifyFn}
                //         toggleDockFn={this.toggleDock}
                //     />
                // );
            });

            // @ts-expect-error
            suppliersVendorsBody = <tbody>{processedSupplierVendorRows}</tbody>;
        }

        return suppliersVendorsBody;
    };

    setColumns = (columns: IColumns) => {
        const cols = Object.keys(columns);
        const tableColumns = this.state.tableColumns;

        for (const col of cols) {
            const column = columns[col];

            for (const tableCol of tableColumns) {
                if (tableCol.title === column.label) {
                    if (!column.isChecked) {
                        tableCol.notVisible = true;
                    } else {
                        tableCol.notVisible = false;
                    }
                }
            }
        }

        this.setState({
            columns,
            tableColumns,
        });
    };

    getVendors = () => {
        if (!this.props.userModel) {
            return;
        }

        const payload: IGetVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            offset: this.state.offset,
            limit: this.state.limit,
            queryString: this.state.queryString,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);

        this.setState({
            getVendorsActive: true,
            isDataFetching: true,
        });
    };

    onPaginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                offset,
                limit,
            },
            () => {
                this.getVendors();
            }
        );
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        if (!this.state.isSidebarOpen) {
            const supplierVendorTokens = data.supplierVendorTokens;

            const state: any = {
                getVendorsActive: false,
                isDataFetching: false,
                isInitialData: false,
            };

            if (supplierVendorTokens) {
                state.supplierVendorTokens = supplierVendorTokens;
            }

            state.totalSupplierVendors = data.totalVendors;

            if (this.state.isReset) {
                state.isReset = false;
            }

            if (data.salesPeopleAssigned) {
                state.salesPeopleAssigned = data.salesPeopleAssigned;
            }

            this.setState(state);
        }
    };

    qboGetAllCustomersFn = (data: any) => {
        const modalComponent = (
            <QuickBooksOnlineConnectCustomersModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.setState({
            activeConnectToQBO: true,
            disableConnectToQBO: true,
            modalComponent,
            modalIsOpen: true,
        });

        // this.setState(
        //     {
        //         activeConnectToQBO: true,
        //         disableConnectToQBO: true,
        //     },
        //     () => {
        //         this.qboGetAllCustomers();
        //     }
        // );
    };

    // onQboGetAllCustomers = (data: any) => {
    //     this.setState({
    //         activeConnectToQBO: false,
    //         disableConnectToQBO: false,
    //     });
    // };

    qboGetAllCustomers = () => {
        const data: IQBOGetAllCustomersDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetAllCustomers, data);

        this.setState({
            disableConnectToQBO: true,
            activeConnectToQBO: true,
        });
    };

    onQboGetAllCustomers = (data: IOnQBOGetAllCustomersDTO) => {
        // after getting the customers, we want to see if any have the same name as the current vendor list.
        const vendorQuickbooksCustomerArr: any[] = [];

        _.each(this.state.supplierVendorTokens, (supplierVendorToken) => {
            _.each(data.customers, (customerObj) => {
                if (supplierVendorToken.Vendor && supplierVendorToken.Vendor.name === customerObj.DisplayName) {
                    const customerEmail = _.get(customerObj, "PrimaryEmailAddr.Address", undefined);

                    const detail = {
                        email: customerEmail,
                        customerId: customerObj.Id,
                        displayName: customerObj.DisplayName,
                        vendorGuid: supplierVendorToken.Vendor.guid,
                        vendorName: supplierVendorToken.Vendor.name,
                    };

                    vendorQuickbooksCustomerArr.push(detail);
                }
            });
        });

        // we need an array of the different vendors guids with their quickbook customer ids

        const payload: IQBOSetBulkVendorCustomerDetailsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            vendorsArr: vendorQuickbooksCustomerArr,
        };

        // push them to the api to update the vendors and refresh the users view.
        this.props.socket.emit(EndpointsEnum.QBOSetBulkVendorCustomerDetails, payload);

        this.setState({
            activeConnectToQBO: false,
            disableConnectToQBO: false,
        });
    };

    onQboSetBulkVendorCustomerDetails = (data: IOnQBOSetBulkVendorCustomerDetailsDTO) => {
        this.setState({
            disableConnectToQBO: false,
            activeConnectToQBO: false,
        });

        const notification: INotification = {
            title: "successfully_synced_with_quickbooks",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };
        this.props.notifyFn(null, notification, false);

        const payload: IGetAllSupplierTokensDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // usersLimit: this.state.usersLimit,
            // usersOffset: this.state.usersOffset,
            // vendorsLimit: this.state.vendorsLimit,
            // vendorsOffset: this.state.vendorsOffset,
            // vendorUsersLimit: this.state.vendorUsersLimit,
            // vendorUsersOffset: this.state.vendorUsersOffset,
        };

        this.props.socket.emit(EndpointsEnum.TokenGetAllSupplierTokens, payload);
    };

    vendorSearch = (queryString: string, searchResults: any, reset: boolean) => {
        const state: any = {
            queryString,
            searchResults,
            offset: 0,
            isReset: true,
        };

        if (reset) {
            state.sortCol = "name";
            state.sortDir = SortOrderEnum.ASC;
        }

        this.setState(state, () => {
            this.getVendors();
        });
    };

    /** Whether this user sees the FilterBar (v2) instead of the legacy search section. */
    usesFilterBarV2 = (): boolean => {
        return getFilterBarMode(UserService.getCurrentToken(this.props.userModel)?.settings).useFilterBar;
    };

    /** FilterBar (v2) search: the bar owns the URL and the filter state, so this only refetches from the first page. */
    filterBarSearch = (queryString: string) => {
        this.vendorSearch(queryString, [], false);
    };

    onSquareGetCustomers = (data: IOnSquareGetCustomersDTO) => {
        const component = (
            <SquareCustomerSync
                supplierModel={this.props.supplierModel}
                userModel={this.props.userModel}
                socket={this.props.socket}
                squareCustomerData={data.squareCustomers}
                vendorData={data.vendorData}
                closeModalFn={this.toggleModal}
            />
        );

        this.toggleModal(component);

        this.setState({
            activeSyncWithSquare: false,
            disableSyncWithSquare: false,
        });
    };

    hubspotPullCompaniesModal = () => {
        const modalComponent = <HubspotPullCompanies closeModalFn={this.closeModal} startModalFn={this.hubspotPullCompanies} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    getVendorsPending = () => {
        if (this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN) {
            const payload: IGetVendorsPendingDTO = {
                includeProcessed: false,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
            };

            this.props.socket.emit(EndpointsEnum.VendorGetVendorsPending, payload);
        }
    };

    onGetVendorsPending = (data: IOnGetVendorsPendingDTO) => {
        this.setState({
            vendorsPending: data.vendorsPending,
        });
    };

    shopifyPullCustomersModal = () => {
        const payload: IShopifySyncCustomersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShopifySyncCustomers, payload);

        this.setState({
            activeShopify: true,
        });
    };

    onShopifySyncCustomers = (data: IShopifyOnSyncCustomersDTO) => {
        const notification: INotification = {
            message: "shopify_sync_complete",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            activeShopify: false,
        });
    };

    hubspotPullCompanies = (options: Partial<IHubspotPullCompaniesDTO>) => {
        const payload: IHubspotPullCompaniesDTO = {
            ...options,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.HubspotPullCompanies, payload);

        this.setState({
            activeHubspot: true,
            modalComponent: null,
            modalIsOpen: false,
            hubspotTotalProcessed: 0,
        });
    };

    onHubspotPullCompanies = (data: IHubspotOnPullCompaniesDTO) => {
        this.setState({
            activeHubspot: false,
        });
    };

    hubspotPullCompaniesProgress = (data: IHubspotPullCompaniesProgressDTO) => {
        this.setState({
            hubspotTotalProcessed: data.totalProcessed,
        });
    };

    getWarehouses = () => {
        const payload: IGetWarehousesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.WarehouseGetWarehouses, payload);
    };

    onGetWarehouses = (data: IOnGetWarehousesDTO) => {
        this.setState({
            warehouses: data.warehouses,
        });
    };

    squareSyncCustomers = () => {
        if (!this.props.userModel) {
            return;
        }

        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.SquareGetCustomers, payload);

        this.setState({
            activeSyncWithSquare: true,
            disableSyncWithSquare: true,
        });
    };

    zohoShowSyncModal = () => {
        const modalComponent = <ZohoSyncAccountsModal closeModalFn={this.closeModal} startSync={this.zohoGetAccounts} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    zohoGetAccounts = (includeContacts: boolean) => {
        if (!this.props.userModel) {
            return;
        }

        const payload: IZohoGetAccountsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            createAccounts: true,
            includeContacts,
        };

        this.props.socket.emit(EndpointsEnum.ZohoGetAccounts, payload);

        this.setState({
            activeSyncWithZoho: true,
            disableSyncWithZoho: true,
            modalIsOpen: false,
            modalComponent: null,
        });
    };

    onZohoGetAccounts = (data: IOnZohoGetAccountsDTO) => {
        this.setState(
            {
                activeSyncWithZoho: false,
                disableSyncWithZoho: false,
                zohoTotalProcessed: data.totalProcessed,
                zohoTotalCreated: data.totalCreated,
                zohoTotalUpdated: data.totalUpdated,
            },
            () => {
                this.getVendors();
            }
        );
    };

    zohoGetAccountsProgress = (data: IZohoGetAccountsProgressDTO) => {
        this.setState({
            zohoTotalProcessed: data.totalProcessed,
        });
    };

    showVendorQBDDataMapper = () => {
        this.setState({
            qbdMapperVisible: true,
        });
    };

    qbdAccountAudit = () => {
        const payload: IQBDAccountAuditDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBDAccountAudit, payload);

        this.setState({
            qbdAccountAuditActive: true,
        });
    };

    onQbdAccountAudit = (data: IQBDOnAccountAuditDTO) => {
        UIService.downloadDataFile(data.workbook, `qbd-account-audit-${this.props.supplierModel.name}.xlsx`, "application/vnd.ms-excel");

        const notification: INotification = {
            message: "account_audit_complete",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            qbdAccountAuditActive: false,
        });
    };

    qbdPushVendors = () => {
        const payload: IQBDPushCustomersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBDPushCustomers, payload);

        this.setState({
            qbdSyncVendorsActive: true,
        });
    };

    onQBDPushVendors = (data: IOnQBDPushCustomersDTO) => {
        this.loadUserData();

        this.setState({
            qbdSyncVendorsActive: false,
        });
    };

    showVendorQBDSync = () => {
        const component = (
            <QBDVendorSyncModal closeModalFn={this.closeModal} startFn={this.startVendorQBDSync} supplierModel={this.props.supplierModel} />
        );

        this.setState({
            modalComponent: component,
            modalIsOpen: true,
        });
    };

    startVendorQBDSync = (performNameBasedLookup: boolean, useBillToForShipTo?: boolean) => {
        this.qbdSyncVendors(performNameBasedLookup, useBillToForShipTo);
    };

    qbdSyncVendors = (performNameBasedLookup: boolean, useBillToForShipTo?: boolean) => {
        const payload: IQBDCreateVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            useBillToForShipTo: useBillToForShipTo || false,
            skipCreateIfNotFound: false,
            skipUpdateAddress: false,
            performNameBasedLookup: performNameBasedLookup || false,
        };

        if (this.props.supplierModel.guid === SupplierGuidEnum.POPMOUNT) {
            payload.skipCreateIfNotFound = true;
            payload.skipUpdateAddress = true;
            payload.performNameBasedLookup = true;
        }

        this.props.socket.emit(EndpointsEnum.QBDCreateVendors, payload);

        this.setState({
            qbdSyncVendorsActive: true,
        });
    };

    onQbdSyncVendors = () => {
        this.getAllSupplierTokens();

        this.setState({
            qbdSyncVendorsActive: false,
        });
    };

    onQboPushCustomers = () => {
        const notification: INotification = {
            message: "successfully_pushed_customers",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.getAllSupplierTokens();

        this.setState({
            activeQboSyncCustomers: false,
        });
    };

    loadUserData = () => {
        const payload: ILoadUserDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    qbdDataMapperSave = (items: IDataMapperSaveItem[]) => {
        if (!this.props.userModel) {
            return null;
        }

        const payload: IQBDMapperDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            resource: ResourceTypesEnum.VENDOR,
            items: _.map(items, (item) => {
                return {
                    resourceGuid: item.staticValue,
                    mapValues: {
                        qbd_ListID: item.selectedItem ? item.selectedItem.ListID : null,
                    },
                };
            }),
        };

        this.props.socket.emit("qbdMapper", payload);
    };

    onQbdMapper = (data: IOnQBDMapperDTO) => {
        this.setState(
            {
                qbdMapperVisible: false,
            },
            () => {
                this.getVendors();
            }
        );
    };

    qbdDataMapperCancel = () => {
        this.setState({
            qbdMapperVisible: false,
        });
    };

    toggleModal = (modalComponent: any) => {
        this.setState(
            {
                modalIsOpen: !this.state.modalIsOpen,
                modalComponent,
            },
            () => {
                if (!this.state.modalIsOpen) {
                    this.getVendors();
                }
            }
        );
    };

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    }

    afterModalClose = () => {
        this.getAllSupplierTokens();
    };

    closeModal = () => {
        this.setState({ modalIsOpen: false, activeConnectToQBO: false });
    };

    showDownloadCsvModal = () => {
        const modalComponent = <AccountDownloadCsvModal onClose={this.closeModal} onStart={this.downloadCsvUpload} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    downloadCsvUpload = (onlyPrimaryAddress?: boolean) => {
        const payload: IGetVendorCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            onlyPrimaryAddress,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendorCsv, payload);
        // const rows = [
        //     [
        //         "Name",
        //         "Email",
        //         "Ship To Address Line One",
        //         "Ship To Address Line Two",
        //         "Ship To Address Line Three",
        //         "Ship To City",
        //         "Ship To State",
        //         "Ship To Postal Code",
        //         "Ship To Country (3 Char.)",
        //         "Ship To Phone",
        //         "Ship To Fax",
        //         "Bill To Address Line One",
        //         "Bill To Address Line Two",
        //         "Bill To Address Line Three",
        //         "Bill To City",
        //         "Bill To State",
        //         "Bill To Postal Code",
        //         "Bill To Country (3 Char.)",
        //         "Bill To Phone",
        //         "Bill To Fax",
        //         "Category",
        //         "Catalog",
        //         "Price Group",
        //     ],
        // ];
        //
        // let csvContent = rows.map((e) => e.join(",")).join("\n");
        //
        // const blob = new Blob([csvContent], { type: "text/csv" });
        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        //
        // const fileName = "Orderwerks Account Upload.csv";
        //
        // link.download = fileName;
        // link.click();
    };

    onGetVendorCsv = (data: IOnGetVendorCsvDTO) => {
        const blob = new Blob([data.csvData], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const fileName = data.filename;

        link.download = fileName;
        link.click();
    };

    showUploadCSV = () => {
        const modalComponent = (
            <VendorCsvModalUpload
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                totalVendors={this.state.totalSupplierVendors}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    closeSyncStatus = () => {
        this.setState({
            showSyncStatus: false,
        });
    };

    saveColumnsAsDefault = (columns: IColumns) => {
        const orderCols: { [key: string]: boolean } = {};

        for (const prop of Object.keys(columns)) {
            orderCols[prop] = columns[prop].isChecked;
        }

        const currentToken = UserService.getCurrentToken(this.props.userModel);

        if (currentToken) {
            const payload: IUpdateTokenSettingsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                settings: {
                    users_vendors_cols: orderCols,
                },
                tokenGuid: currentToken.guid,
            };

            this.props.socket.emit(EndpointsEnum.TokenUpdateSettings, payload);
        }
    };

    onUpdateTokenSettings = (data: IOnUpdateUserSettingsDTO) => {
        // Saved columns and FilterBar presets both write token settings, so the reply can be either.
        const notification: INotification = {
            message: "successfully_updated_settings",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);
    };

    render() {
        if (_.isNil(this.state.supplierVendorTokens)) {
            return null;
        }

        const vendors = this.state.supplierVendorTokens.map((token) => {
            return token.Vendor;
        });

        let limitArr: any;

        if (this.props.supplierModel.has_rep_groups) {
            limitArr = [
                { value: 5, isSelected: false },
                { value: 10, isSelected: false },
                { value: 25, isSelected: false },
                { value: 50, isSelected: false },
            ];
        }

        return (
            <div className="SupplierVendors pb-2 position-relative">
                {this.state.supplierVendorTokens.length && this.state.qbdMapperVisible ? (
                    <OwDataMapper
                        isVisible={this.state.qbdMapperVisible}
                        saveFn={this.qbdDataMapperSave}
                        cancelFn={this.qbdDataMapperCancel}
                        mainTitle={"vendor_mapper"}
                        staticTitle={"vendors"}
                        staticOptions={vendors}
                        staticValueProp={"guid"}
                        staticValueSelectedProp={"Vendor_Integration"}
                        staticValueSelectedSubProp={"qbd_ListID"}
                        staticTitleProp={"name"}
                        staticSubTitleProp={"email"}
                        selectableTitle={"quickbooks_customers"}
                        selectableOptions={this.state.qbdSelectableOptions}
                        selectableValueProp={"ListID"}
                        selectableTitleProp={"Name"}
                    />
                ) : null}

                <div className={"row  mb-2"}>
                    <div className={"col-12"}>
                        <AccountsHeader
                            notifyFn={this.props.notifyFn}
                            showSupplierVendorSidebar={this.showSupplierVendorSidebar}
                            downloadCsv={this.showDownloadCsvModal}
                            uploadCsvModal={this.showUploadCSV}
                        />
                        {this.props.showHiddenFeatures && (
                            <div>
                                <OwToggle
                                    fn={() => {
                                        this.setState({
                                            useNewVendorSidebar: !this.state.useNewVendorSidebar,
                                        });
                                    }}
                                    name={"use_new_vendor_sidebar"}
                                    label={"use_new_vendor_sidebar"}
                                    active={!!this.state.useNewVendorSidebar}
                                    labelOnRight={true}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className={"row mb-2"}>
                    <div className={"col-12 d-flex align-items-center"}>
                        {this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN ? (
                            <div className={"ms-auto d-flex"}>
                                {this.state.showSyncStatus ? (
                                    <div className={"ms-2"}>
                                        <SyncStatus
                                            closeFn={this.closeSyncStatus}
                                            showClose={true}
                                            totalItems={this.state.syncTotalItems}
                                            totalProcessed={this.state.syncTotalProcessed}
                                            totalErrors={this.state.totalErrors}
                                            errorDetails={this.state.errorDetails}
                                        />
                                    </div>
                                ) : null}

                                {this.state.activeSyncWithZoho ? (
                                    <div className={"ms-2"}>
                                        <OwLabel title={"total_processed"} postText={":"} className={"me-2"} />
                                        {this.state.zohoTotalProcessed}
                                    </div>
                                ) : null}

                                {this.state.activeHubspot ? (
                                    <div className={"ms-2"}>
                                        <OwLabel title={"total_processed"} postText={":"} className={"me-2"} />
                                        {this.state.hubspotTotalProcessed}
                                    </div>
                                ) : null}

                                {this.state.qbdSyncVendorsActive ? (
                                    <div className={"ms-2"}>
                                        <QBDVendorsSyncStatus socket={this.props.socket} />
                                    </div>
                                ) : null}

                                {/*<div className={"ms-2"}>*/}
                                {/*    <OwButton title={"download_csv_upload"} fn={this.downloadCsvUpload} leftIconClass={"fad fa-download"} />*/}
                                {/*</div>*/}

                                {/*<div className={"ms-2"}>*/}
                                {/*    <OwButton*/}
                                {/*        className={"btn-danger"}*/}
                                {/*        title={"upload_csv"}*/}
                                {/*        fn={this.showUploadCSV}*/}
                                {/*        leftIconClass={"fad fa-upload"}*/}
                                {/*    />*/}
                                {/*</div>*/}
                            </div>
                        ) : null}
                    </div>
                </div>

                {/* Legacy / FilterBar (v2) search toggle, and the portal target for the v2 Refresh + Filters buttons */}
                <div className={"d-flex align-items-center mb-2"}>
                    <div className={"ms-auto d-flex align-items-center"}>
                        <FilterBarVersionToggle />
                        <div id={VENDORS_FILTER_ACTIONS_ID} className={"d-flex align-items-center ms-2 d-print-none"} />
                    </div>
                </div>

                <div className={"mb-2"}>
                    {this.usesFilterBarV2() ? (
                        <VendorsFilterBar isSearching={this.state.isDataFetching} searchFn={this.filterBarSearch} />
                    ) : (
                        <SearchSection>
                            <VendorsFilter
                                searchFn={this.vendorSearch}
                                sortDir={this.state.sortDir}
                                sortCol={this.state.sortCol}
                                categories={this.state.categories}
                            />
                        </SearchSection>
                    )}
                </div>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <OwActionBar
                            toggleSmallTable={() => {
                                this.setState({ showMapsView: !this.state.showMapsView });
                            }}
                            colToggledFn={this.setColumns}
                            columns={this.state.columns}
                            hideTableTypeSelect={false}
                            actions={this.state.actions}
                            supplierModel={this.props.supplierModel}
                            disabled={false}
                            saveAsDefaultsFn={this.saveColumnsAsDefault}
                        />
                    </div>

                    <div className={"d-flex"}>{/*<TableColumnSelect colToggledFn={this.setColumns} columns={this.state.columns} />*/}</div>
                </div>

                <div className={"text-end"}>
                    <OwLabel title={"total_rows"} postText={":"} className={"me-2"} />
                    {this.state.totalSupplierVendors}
                </div>

                {this.state.vendorsPending.length ? (
                    <VendorsPending pending={this.state.vendorsPending} refreshFn={this.getVendorsPending} />
                ) : null}

                <div className="row mb-2">
                    <div className={"col-12 position-relative"}>
                        <ConfirmDeleteOverlayFn
                            targetElem={this.state.revokeRow}
                            handleConfirm={this.commitDelete}
                            handleCancel={this.cancelDelete}
                            message={"connections.are_sure_revoke_token"}
                            leftAdjustment={-12}
                            topAdjustment={-15}
                            nestedParentElem={"VendorTable"}
                            skipMainView={true}
                        />

                        {/*<div className="table-responsive">*/}
                        <OwDoubleScrollbar
                            childElemClass={"vendorTable"}
                            isElemDataLoading={this.state.isDataFetching}
                            pinToHeader={true}
                            viewElemClass={"VendorTable"}>
                            <OwTable
                                noDefaultWrappingClassName={true}
                                id={"VendorTable"}
                                tableClassName={"vendorTable"}
                                columns={this.state.tableColumns}
                                dataSet={this.state.supplierVendorTokens}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                dataFetch={this.state.isDataFetching}
                                initialData={this.state.isInitialData}
                                tableConfig={this.state.tableConfig}
                                currentSortCol={this.state.sortCol}
                                maintainTableHeight={true}
                            />
                        </OwDoubleScrollbar>
                        {/*</div>*/}
                    </div>
                </div>

                <div className={"col-12"}>
                    <PaginationBar
                        limit={this.state.limit}
                        offset={this.state.offset}
                        totalRecords={this.state.totalSupplierVendors}
                        onPaginationChanged={this.onPaginationChanged}
                        isActive={this.state.getVendorsActive}
                        limitArr={limitArr}
                    />
                </div>

                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    onAfterClose={this.afterModalClose}
                    contentLabel="Orderwerks"
                    shouldCloseOnOverlayClick={false}
                    style={this.state.modalStyle}
                    className={"modalContentClass"}
                    overlayClassName={"modalOverlayClass"}>
                    {this.state.modalComponent}
                </Modal>

                <Dock
                    size={0.45}
                    dockStyle={{ backgroundColor: "#313439", color: "white" }}
                    position="bottom"
                    isVisible={this.state.isDockVisible}>
                    {" "}
                    <div className={"p-2"}>
                        <div className="text-end">
                            <span
                                className="pointer"
                                onClick={() => {
                                    this.toggleDock();
                                }}>
                                X
                            </span>
                        </div>

                        <div className="">{this.state.dockComponent}</div>
                    </div>
                </Dock>
            </div>
        );
    }
}

export default SupplierVendors;
